import { RouteComponentProps } from "react-router-dom";

const createHistory = require("history").createBrowserHistory;

export const history: RouteComponentProps["history"] = createHistory();
